import { ConfigService } from './config.service';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { Http } from '@angular/http';

@NgModule({
    providers: []
})
export class ConfigModule {

    public static forRoot(): ModuleWithProviders {

        return {
            ngModule: ConfigModule,
            providers: [{
                // We'll create a singleton of the ConfigService instance.
                provide: ConfigService,
                useClass: ConfigService,
                deps: ['ENVIRONMENT', Http]
            }]
        };
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/config/config.module.ts